import * as JSONPath from 'jsonpath-plus'
import { JsonPathExpressionType } from './interfaces'

class ObjectParser {
  static Query<T>(json: any, path: JsonPathExpressionType): T[] {
    return JSONPath({ json, path }) as T[]
  }

  static QueryAndGetFirst<T>(json: any, path: JsonPathExpressionType): T {
    let first = JSONPath({ json, path })[0]

    if (first && !isNaN(first)) {
      first = Number(first)
    }

    return first as T
  }

}

export {
  ObjectParser
}
